<template lang="pug">
  #app.color-light.lang-en
    Block.bg
      .top-bar.pading-y-m
        .left
          logo
        //- .lang
          .en.color-button-sub.t-center.pointer.ani-fast.color-text-3.radius-m.current EN
          .sc.color-button-sub.t-center.pointer.ani-fast.color-text-3.radius-m 中
          .jp.color-button-sub.t-center.pointer.ani-fast.color-text-3.radius-m JP
    Block.bg
      hero
    //- Block.bg
      hero-hor
    //- Block.bg-2
      .body.pading-y-l
        .headline
          //- h2.fz-h-l-2.t-center 创作内容应该像乐高一样简单
          h2.lh-h.fz-ll.f-z-h-l-2.t-center Compose. Publish. Share.
          //- p.p.fz-p-l.color-text-2 使用 Bento 非常一样简单。只要选择合适的页面组件，把它们按照你想要的组合起来即可。只要你会玩乐高，你就会用 Bento。
          p.p.lh-p.fz-m.f-z-p-l.color-text-2.t-center Using Bento is as simple as LEGO. Just select the right components and combine them in whatever way you want.
        .features
          feature(
            :imgsrc="require('@/assets/feature/1.png')"
            title="Versatile Components"
            paragraph="Compose text, images, form elements, and community-created components to realize all the features for your website."
          )
          feature(
            :imgsrc="require('@/assets/feature/2.png')"
            title="For you, more for your team"
            paragraph="You can do all the work yourself without the help of anyone. Or let your team work on the same page."
          )
          feature(
            :imgsrc="require('@/assets/feature/3.png')"
            title="Real & real-time data"
            paragraph="Connect to data sources to present real and live data. Updating the content no longer has to bother anyone, including yourself."
          )
          feature(
            :imgsrc="require('@/assets/feature/4.png')"
            title="Control your publication"
            paragraph="You can decide whether to share your publication inside the team or be completely open. And you can find detailed analysis."
          )
    //- Block.bg
      cta
    //- Block.bg-2
      footer.footer.pading-y-l
        .brand
          logo
          //- .copyright.fz-p-s.color-text-3 Bento Inc. 2018
        .company
          .lh-p.fz-s.color-text.bold Company
          //- a.lh-p.fz-s.color-text-2 About Us
          //- a.lh-p.fz-s.color-text-2 Marketplace
          a.lh-p.fz-s.color-text-2(href="https://www.notion.so/bento/Terms-be23f10e8c7b4c6292ea2a4a7dd11497" target="blank") Terms
          a.lh-p.fz-s.color-text-2(href="https://www.notion.so/bento/Privacy-Policy-a701664fb00646019e4a232569d9d657" target="blank") Privacy Policy
        .follow
          .lh-p.fz-s.color-text.bold Follow us
          a.lh-p.fz-s.color-text-2(href="https://twitter.com/makebento" target="blank") Twitter
          a.lh-p.fz-s.color-text-2(href="https://www.facebook.com/id/" target="blank") Facebook
          //- a.lh-p.fz-s.color-text-2 Product Hunt
          a.lh-p.fz-s.color-text-2(href="" target="blank") Instagram

</template>

<script>
import Block from "./components/Block.vue";
import SignUp from "@/components/signup.vue";
import feature from "@/components/feature.vue";
import logo from "@/components/logo.vue";
import hero from "@/components/hero.vue";
import heroHor from "@/components/heroHor.vue";
import cta from "@/components/cta.vue";

export default {
  name: "app",
  components: {
    Block,
    SignUp,
    feature,
    logo,
    hero,
    heroHor,
    cta
  }
};
</script>

<style lang="stylus">
@require "styles/reset"
@require 'styles/layout/main'
@require 'styles/design/main'

.bg
  background var(--clr-bg)
.bg-2
  background var(--clr-bg-2)

.pading-y-l
  padding-top 8rem
  padding-bottom 8rem
.pading-y-m
  padding-top 2rem
  padding-bottom 2rem

.max-w
  max-width 42rem
  align-self center


</style>

<style lang="stylus" scoped>
@require 'styles/layout/main'
@require 'styles/design/main'

#app
  width 100%
  max-width 100%
  stack(y, gap: 0, ali: stretch)
  overflow-x hidden
  &>*
    width 100%

// general class above

.top-bar
  stack(x, gap:.75rem, arr: between, ali:center)
  .left
    line-height 0
  .lang
    stack(x, gap: .125rem)
    &>*
      width 2.5rem
      padding .5rem 0
      &.current
        @extend .color-text-2
        background var(--clr-bg-2)

.body
  min-width 100%
  stack(y, gap: 4rem, ali: stretch)
  // min-width 100%
.headline
  stack(y, gap: 2rem, ali: center)
  &>.p
    max-width 34rem

// .features
.features[max-width~="399px"]
  gridflow(gap:2rem, colmin: 18rem, colmax: 1fr)
.features[min-width~="400px"]
  gridflow(gap:2rem, colmin: 24rem, colmax: 1fr)

.footer
  .company
  .follow
    stack(y, gap: .5rem)
  a:hover
    color var(--clr-content)
.footer[max-width~="499px"]
  stack(y, gap: 2rem, arr: stretch)
  .company
  .follow
    padding-left 2.5rem
.footer[min-width~="500px"]
  stack(x, gap: 6rem, arr: center)

</style>
